export interface CioFeatureFlag {
  featureName: string;
  featureValue: string;
}

const toKey = (flags: CioFeatureFlag[]) =>
  flags
    .map(f => `${f.featureName}:${f.featureValue}`)
    .sort()
    .join(',');

const pushedKeys = new Set<string>();

export const pushCioFeatureFlagsToDataLayer = (flags: CioFeatureFlag[]) => {
  if (flags.length === 0) return;

  const dataLayer = (window.dataLayer = window.dataLayer || []);
  const key = toKey(flags);

  if (pushedKeys.has(key)) return;

  const alreadyInDataLayer = dataLayer.some(
    (entry: Record<string, unknown>) =>
      Array.isArray(entry.cioFeatureFlags) &&
      toKey(entry.cioFeatureFlags as CioFeatureFlag[]) === key
  );

  if (!alreadyInDataLayer) {
    dataLayer.push({ cioFeatureFlags: flags });
  }

  pushedKeys.add(key);
};

/** @internal Exposed for testing only */
export const resetCioFeatureFlagsTracking = () => {
  pushedKeys.clear();
};
